import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Cookie-only auth: the httponly access_token cookie is sent automatically via
// withCredentials. CSRF uses a stateless signed token delivered by /auth/me and
// login (kept in memory) and echoed as X-CSRF-Token on state-changing requests.
const api = axios.create({ baseURL: API, withCredentials: true });

let _csrf = null;
export function setCsrf(t) { if (t) _csrf = t; }

api.interceptors.request.use((config) => {
  const actAs = localStorage.getItem("azx_act_as");
  if (actAs) config.headers["X-Act-As-Tenant"] = actAs;
  const method = (config.method || "get").toUpperCase();
  if (["POST", "PUT", "PATCH", "DELETE"].includes(method) && _csrf) {
    config.headers["X-CSRF-Token"] = _csrf;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config;
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    const isCsrf = status === 403 && typeof detail === "string" && detail.includes("CSRF");
    // A stale/expired token: refresh it once from /auth/me and retry the request.
    if (isCsrf && cfg && !cfg._csrfRetry) {
      cfg._csrfRetry = true;
      try {
        const { data } = await api.get("/auth/me");
        if (data?.csrf) {
          setCsrf(data.csrf);
          cfg.headers["X-CSRF-Token"] = data.csrf;
          return api(cfg);
        }
      } catch (e) { /* fall through to reject */ }
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
